import { defineComponent as _defineComponent } from 'vue'
import { NewBuyBoxView } from '@/stores/user.store';
import { useUserStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { computed } from 'vue';
import { useBuyboxLoggedInExp } from '@/components/experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';
import { useTitlePageLoggedInExp } from '@/components/experiments/TitlepageLoggedInExp/composables/useTitlepageLoggedInExp';
import { useFauxSwiperExp } from '@/components/experiments/FauxSwiperExp';
import { faTimes, faInfoCircle, faTableCells, faList } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxTypeSwitcher',
  props: {
    additionalContexts: null,
    buyBoxType: null
  },
  emits: ["buyBoxTypeSwitched"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'buyBoxTypeSwitched', payload: { buyBoxType: NewBuyBoxView }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	additionalContexts: SnowplowContext[];
	buyBoxType?: NewBuyBoxView;
};





const {
	newBuyboxTooltipAcknowledged,
	setNewBuyboxTooltipAcknowledged,
	newBuyboxView,
	setNewBuyboxView,
	isUserFirstVisit,
	isLoggedIn,
	loggedInExpBuyboxView,
} = useUserStore();

const { t } = useI18n();
const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();

// FAUX_SWIPER_EXP
const { trackFauxSwiperExp } = useFauxSwiperExp();
// FAUX_SWIPER_EXP

const { titlePageActiveVariant } = useTitlePageLoggedInExp();

const buyboxView = computed(() => {
	if (!!props.buyBoxType) {
		return props.buyBoxType;
	}

	if (!!titlePageActiveVariant.value && titlePageActiveVariant.value !== 'control') {
		return loggedInExpBuyboxView.value;
	}

	return newBuyboxView.value;
});

const showTooltip = computed(() => {
	if (isLoggedIn.value) {
		return !newBuyboxTooltipAcknowledged.value;
	}
	return !newBuyboxTooltipAcknowledged.value && isUserFirstVisit.value === false;
});

const handleListClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.LIST });
	} else {
		setNewBuyboxView(NewBuyBoxView.LIST);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.LIST);
};

const handleGridClicked = () => {
	if (!!props.buyBoxType) {
		emit('buyBoxTypeSwitched', { buyBoxType: NewBuyBoxView.GRID });
	} else {
		setNewBuyboxView(NewBuyBoxView.GRID);
		setNewBuyboxTooltipAcknowledged();
	}
	trackToggleEvent(NewBuyBoxView.GRID);
};

const trackToggleEvent = (label: NewBuyBoxView) => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_view_clicked', label }, props.additionalContexts);
	trackBuyboxLoggedInExp({
		action: 'click',
		label: `buybox_view_clicked_${label}`,
	});

	// FAUX_SWIPER_EXP
	trackFauxSwiperExp({
		action: 'click',
		label: `buybox_view_clicked_${label}`,
	});
	// FAUX_SWIPER_EXP
};

const close = () => {
	TrackingHelper.trackEvent('userinteraction', { action: 'buybox_switch_acknowledged' }, props.additionalContexts);
	setNewBuyboxTooltipAcknowledged();
};

return { __sfc: true,props, emit, newBuyboxTooltipAcknowledged, setNewBuyboxTooltipAcknowledged, newBuyboxView, setNewBuyboxView, isUserFirstVisit, isLoggedIn, loggedInExpBuyboxView, t, trackBuyboxLoggedInExp, trackFauxSwiperExp, titlePageActiveVariant, buyboxView, showTooltip, handleListClicked, handleGridClicked, trackToggleEvent, close, faTimes, faInfoCircle, faTableCells, faList }
}

})